import { render } from "./zoom.vue?vue&type=template&id=e8e99970&lang=pug&bindings={}"
import script from "./zoom.vue?vue&type=script&lang=js"
export * from "./zoom.vue?vue&type=script&lang=js"

import "./zoom.vue?vue&type=style&index=0&lang=sass"
script.render = render

export default script